import React from 'react';
import {FieldArray, useFormikContext} from 'formik';
import {Button, Icon, Input} from '../UI';
import { FormValues } from '../../common/interfaces';
import {MaskedInput} from '../UI/MaskedInput';

export const EmergencyContacts = () => {
  const { values } = useFormikContext<FormValues>();

  return (
    <FieldArray name="emergencyContacts">
      {({ push, remove }) => (
        <div className="space-y-4">
          {values.emergencyContacts.map((_, index) => (
            <div key={index} className="flex">
              <span className="w-10 text-slate-500 font-semibold mt-8">{index + 1}.</span>

              <div className="w-full grid grid-cols-2 gap-6">
                <Input name={`emergencyContacts.${index}.name`} label="Name" />
                <MaskedInput name={`emergencyContacts.${index}.phone`} label="Phone Number" mask='(999) 999-9999' />
                <Input name={`emergencyContacts.${index}.address`} label="Address" />
                <Input name={`emergencyContacts.${index}.relation`} label="Relation" />
              </div>

              {values.emergencyContacts.length > 1 && (
                <Button onClick={() => remove(index)}>
                  <Icon prefix='fal' icon='trash-alt' />
                </Button>
              )}
            </div>
          ))}

          <div className='flex justify-end'>
            <Button
              type='button'
              size='xs'
              onClick={() => push({ name: '', phone: '', address: '', relation: '' })}>
              + Add Contact
            </Button>
          </div>
        </div>
      )}
    </FieldArray>
  );
};